import React, { useState } from 'react';
import PropTypes from 'prop-types';

import Carousel, { Slide } from '../../library/carousel/carousel';
import Image from '../../library/image/image';
import Link from '../../library/link/link';

import { trackAction } from '../../shared/utils/analytics/analytics';
import { isArrayWithLength } from '../../shared/utils/validators/validators';

import {
  PROMO_AMOUNT,
  PROMO_CODE,
  PROMO_CREATIVE,
  PROMO_NAME,
  PROMO_POSITION
} from '../../shared/constants/data-layer';

import './cms-filtered-promotions.scss';

function CmsFilteredPromotions(props) {
  const { promotions } = props;

  const [slideIndex, setSlideIndex] = useState(0);

  function onSlideChange(slideIndex) {
    setSlideIndex(slideIndex);
  }

  function trackPromotion(promo, position) {
    const { image, code } = promo || {};
    const { url, altText } = image || {};
    const [amount] = altText?.match(/\$?\d+%?/) || [];

    trackAction('promotion_select', {
      [PROMO_AMOUNT]: amount,
      [PROMO_CODE]: code,
      [PROMO_CREATIVE]: url,
      [PROMO_NAME]: altText,
      [PROMO_POSITION]: position
    });
  }

  return (
    <div styleName="container">
      <div styleName="carousel-wrapper">
        {isArrayWithLength(promotions) && (
          <Carousel
            onSlideChange={onSlideChange}
            showIndicators
            slideIndex={slideIndex}
          >
            {promotions.map((promo, idx) => (
              <Slide key={`cfp-${idx}`} shouldLazyLoad styleName="slide">
                <Link
                  onClick={() => {
                    trackPromotion(promo, idx);
                  }}
                  styleName="promo-link"
                  to={promo.link?.href}
                >
                  <Image
                    alt={promo.image.altText}
                    height="100"
                    src={promo.image?.url}
                    width="300"
                  />
                </Link>
              </Slide>
            ))}
          </Carousel>
        )}
      </div>
    </div>
  );
}

CmsFilteredPromotions.propTypes = {
  promotions: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.object,
      link: PropTypes.object
    })
  )
};

export default CmsFilteredPromotions;
